module.exports = __webpack_public_path__ + "static/img/coupon1.af4e3a19.png";